import { useMemo, useRef } from "react";

function useTierCarriers(
  strategicCarriers: StrategicCarrier[],
  selectedTiers: string[] = ["Tier 1", "Tier 2"],
): TierCarrierGroup[] {
  const selectedTiersRef = useRef(selectedTiers);
  return useMemo(() => {
    if (strategicCarriers.length === 0) {
      return [];
    }

    const groupedByTier = strategicCarriers.reduce<{
      [key: string]: StrategicCarrier[];
    }>((acc, item) => {
      const { tier } = item;
      if (
        selectedTiersRef.current &&
        !selectedTiersRef.current.includes(tier)
      ) {
        return acc;
      }
      if (!acc[tier]) {
        acc[tier] = [];
      }
      acc[tier].push(item);
      return acc;
    }, {});
    const shouldAddTitlePostfix =
      Object.keys(groupedByTier).length === selectedTiersRef.current.length;
    return Object.entries(groupedByTier)
      .sort(
        ([keyA], [keyB]) =>
          selectedTiersRef.current.indexOf(keyA) -
          selectedTiersRef.current.indexOf(keyB),
      )
      .map(([key, tiers]) => {
        const title = `Strategic Carriers${shouldAddTitlePostfix ? ` - ${key}` : ""}`;
        return {
          title,
          tiers,
        };
      });
  }, [strategicCarriers]);
}

type TierCarrierGroup = {
  title: string;
  tiers: StrategicCarrier[];
};

type StrategicCarrier = {
  createdAt: string;
  externalId: string;
  id: number;
  name: string;
  tier: string;
  updatedAt: string;
};

export default useTierCarriers;
